import Reveal from '@/components/feature/Reveal';
import SectionTitle from './SectionTitle';
import { GUIDE_STEPS } from '@/mocks/anime';

export default function Guide() {
  return (
    <section id="guide" className="bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 md:gap-14">
          {/* 左：攻略文案 */}
          <div>
            <Reveal>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3.5 py-1 text-xs font-semibold text-secondary-700">
                <i className="ri-compass-3-fill"></i>
                使用攻略
              </span>
              <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">一分钟上手，追更不迷路</h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
                卡通动漫第一页把入口做成了「打开即看」。无论你是刚入坑的追番萌新，还是资深老漫迷，只要记住下面四个步骤，就能轻松找到想看的动漫，并第一时间跟上新番更新。
              </p>
            </Reveal>

            <div className="mt-8 space-y-4">
              {GUIDE_STEPS.map((step, i) => (
                <Reveal key={step.title} delay={i * 80}>
                  <div className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                      <i className={`${step.icon} text-xl`}></i>
                    </span>
                    <div>
                      <h3 className="font-heading text-base text-foreground-950">
                        <span className="mr-2 text-secondary-600">0{i + 1}</span>
                        {step.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-6 text-foreground-600">{step.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* 右：配图卡片 */}
          <Reveal delay={120}>
            <div className="relative">
              <div className="anim-blob absolute -left-6 -top-6 h-40 w-40 rounded-full bg-primary-200/50 blur-2xl"></div>
              <div className="anim-blob absolute -bottom-6 -right-6 h-40 w-40 rounded-full bg-accent-200/50 blur-2xl" style={{ animationDelay: '-8s' }}></div>
              <div className="relative overflow-hidden rounded-3xl border border-background-200 bg-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20hand-drawn%20anime%20illustration%20of%20a%20young%20person%20relaxing%20on%20a%20sofa%20with%20laptop%20and%20headphones%20watching%20anime%2C%20floating%20screens%20and%20sparkles%20around%2C%20warm%20cozy%20room%20background%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20clean%20flat%20illustration%20style&width=900&height=1100&seq=guide-img-01&orientation=portrait"
                  alt="使用卡通动漫第一页追更动漫的舒适场景"
                  className="h-full w-full object-cover"
                />
                {/* 浮层提示 */}
                <div className="absolute bottom-5 left-5 right-5 rounded-2xl border border-background-50/30 bg-black/35 p-4 backdrop-blur">
                  <p className="flex items-center gap-2 text-sm font-semibold text-background-50">
                    <i className="ri-bookmark-3-fill text-secondary-300"></i>
                    收藏本站，追更更方便
                  </p>
                  <p className="mt-1 text-xs text-background-100/85">加入书签后，打开浏览器一键直达卡通动漫第一页首页。</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}